<script setup lang="ts">
defineProps<{
  items?: {
    title: string
    link: StoryBlokLink
    items?: {
      title: string
      items: {
        title: string
        link: StoryBlokLink
        tag?: string
      }[]
      icon?: StoryBlokIcon
    }[]
    tag?: string
    icon?: StoryBlokIcon
    image?: StoryBlokImage
  }[]
}>()

const emit = defineEmits(['isMenuOpen'])
const sections = ref([])
const openMenus = ref<number[]>([])

function toggleNavigationSection(id: number) {
  const navigationSection: HTMLElement = sections.value.find((item: HTMLElement) => Number(item.id) === Number(id)) || new HTMLElement()

  if (navigationSection?.classList.contains('<lg:hidden')) {
    navigationSection?.classList.remove('<lg:hidden')
    openMenus.value.push(id)
  }
  else {
    navigationSection?.classList.add('<lg:hidden')
    openMenus.value = openMenus.value.filter((item: number) => item !== id)
  }
}
</script>

<template>
  <div v-for="(menuItem, i) in items" class="group">
    <StoryblokLink
      v-if="!menuItem.items?.length" class="block h-full <lg:px-2" v-bind="menuItem.link"
      @click="emit('isMenuOpen', false)"
    >
      <div
        class="p-2 text-large flex items-center justify-between duration-200 cursor-pointer lg:hover:text-gray-special lg:text-small lg:h-full lg:px-4"
        :class="[!items?.length && 'lg:p-5']"
      >
        <div class="flex items-center">
          <AppIcon v-if="menuItem.icon?.icon" v-bind="menuItem.icon" size="20" class="mr-3" />
          <span class="xl:whitespace-nowrap">{{ menuItem.title }}</span>
        </div>
      </div>
    </StoryblokLink>
    <div v-else class="h-full items-center <lg:px-2 <lg:flex <lg:justify-between">
      <StoryblokLink class="block h-full w-full my-auto" v-bind="menuItem.link">
        <div
          class="p-2 text-large flex items-center justify-between menu-item gap-1.5 lg:hover:text-gray-special lg:text-small lg:h-full"
        >
          <div class="flex items-center gap-3">
            <AppIcon v-if="menuItem.icon?.icon" v-bind="menuItem.icon" size="20" />
            <span class="xl:whitespace-nowrap">{{ menuItem.title }}</span>
          </div>
          <AppIcon
            v-if="menuItem.items?.length" icon="far-angle-down" size="20"
            class="hidden lg:block group-hover:transform group-hover:rotate-x-180"
          />
        </div>
      </StoryblokLink>
      <AppIcon
        v-if="menuItem.items?.length" icon="far-angle-down" size="20" class="block ml-1.5 cursor-pointer lg:hidden"
        :class="[openMenus.includes(i) && 'transform rotate-x-180']" @click="toggleNavigationSection(i)"
      />
    </div>
    <div
      v-if="menuItem.items?.length" :id="i.toString()" ref="sections"
      :class="[(i === (items.length - 1)) && 'lg:-ml-30']"
      class="p-2 flex bg-white flex-col justify-center gap-2 <lg:hidden <lg:p-4 lg:shadow-hover lg:rounded-xl lg:text-black lg:-mt-1 lg:hidden lg:group-hover:flex lg:z-50 lg:min-w-250px lg:absolute lg:bg-white lg:py-5"
    >
      <div v-for="(sectionItem, j) in menuItem.items">
        <TheNavigationSection :item="sectionItem" @is-menu-open="emit('isMenuOpen', false)" />
        <hr v-if="j !== (menuItem.items.length - 1)" class="my-2">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.router-link-active {
  @apply bg-white text-primary pointer-events-none
}
</style>
